import { Screen } from 'quasar';
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { MOBILE_TITLE_WIDTH_LIMIT } from 'src/services/constants';

export function usePageTitle(forceMobileSize = ref(false)) {
  const store = useStore();

  const dynamicPageTitle = computed(() => Boolean(store?.state.app.dynamicPageTitle));
  const mobileTitle = computed(() => store?.state.app.mobileTitle || '');
  const pageTitlePending = computed(() => Boolean(store?.state.app.pageTitlePending));
  const pageTitle = computed(() => store?.state.app.pageTitle || '');
  const isAtMobileTitleSize = computed(() =>
    Boolean(forceMobileSize?.value || Screen.width < MOBILE_TITLE_WIDTH_LIMIT || Screen.mobileHeight)
  );

  const hasATitle = computed(() => Boolean((isAtMobileTitleSize.value && mobileTitle.value) || pageTitle.value));

  /**
   * @param {string} title
   */
  function setMobileTitle(title) {
    return store.dispatch('app/setMobileTitle', title);
  }

  /**
   * @param {boolean} isPending
   */
  function setPageTitlePending(isPending) {
    return store.dispatch('app/setPageTitlePending', isPending);
  }

  /**
   * @param {string} title
   */
  function setPageTitle(title) {
    return store.dispatch('app/setPageTitle', title);
  }

  return {
    dynamicPageTitle,
    hasATitle,
    isAtMobileTitleSize,
    mobileTitle,
    pageTitle,
    pageTitlePending,
    setMobileTitle,
    setPageTitle,
    setPageTitlePending,
  };
}
